import { PERMISSIONS } from '../../core/utils/permissions';
import { queryKeys } from '../../core/api/queryKeys';

export const REPORT_PERMISSIONS = {
  READ: PERMISSIONS.REPORTS_READ,
};

export const REPORT_QUERY_KEYS = queryKeys.reports;

export const REPORT_CATEGORIES = [
  'STEEL_IRON',
  'COATED_STEEL',
  'BUILDING_MATERIALS',
  'INDUSTRIAL_CHEMICALS',
  'HEAVY_EQUIPMENT',
  'OTHER',
];

export const REPORT_REGIONS = [
  'RIYADH',
  'MAKKAH',
  'MADINAH',
  'EASTERN',
  'QASSIM',
  'ASIR',
  'TABUK',
  'HAIL',
  'NORTHERN_BORDERS',
  'JAZAN',
  'NAJRAN',
  'AL_BAHAH',
  'AL_JAWF',
];
